import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CompendiumShortTermRentalJoinService } from '../compendiums-short-term-rental-join.service';
import { CompendiumShortTermRentalJoin } from '../compendiums-short-term-rental-join';
import { CompendiumShortTermRentalJoinComponent } from '../compendiums-short-term-rental-join/compendiums-short-term-rental-join.component';

@Component({
    selector: 'app-compendiums-short-term-rental-join-list',
    templateUrl: './compendiums-short-term-rental-join-list.component.html',
    styleUrls: ['./compendiums-short-term-rental-join-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CompendiumShortTermRentalJoinListComponent implements OnInit {
	chargeTypes: any;
	feeTypes: any;
	feeFrequencies: any;
	constructor(
		private compendiumShortTermRentalJoinService: CompendiumShortTermRentalJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = compendiumShortTermRentalJoinService.statuses;
		this.chargeTypes = compendiumShortTermRentalJoinService.chargeTypes;
		this.feeTypes = compendiumShortTermRentalJoinService.feeTypes;
		this.feeFrequencies = compendiumShortTermRentalJoinService.feeFrequencies;
	}

	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() compendiumId: any;
	@Input() shortTermRentalId: any;
	@Input() targetPropertyLength: any;
	@Output() reloadProperties = new EventEmitter<any>();
	compendiumShortTermRentalJoins: any;
	compendiumShortTermRentalJoin: CompendiumShortTermRentalJoin;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'ShortTermRentalVO.propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'ShortTermRentalVO.bedrooms', header: 'Bedrooms', width: 'auto' },
		{ field: 'ShortTermRentalVO.addressCounty', header: 'County', width: 'auto' },
		{ field: 'ShortTermRentalVO.addressState', header: 'State', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.compendiumShortTermRentalJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) { 
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-compendiumShortTermRentalJoin-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.compendiumId)
			{
				// show only activities that are assigned to this activityId
				let compendiumIdFilter = { 'compendiumId': { 'value': this.compendiumId, 'matchMode': 'in' } };
				Object.assign(event.filters, compendiumIdFilter);
			}

			if(this.shortTermRentalId)
				{
					// show only activities that are assigned to this activityId
					let shortTermRentalIdFilter = { 'shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
					Object.assign(event.filters, shortTermRentalIdFilter);
				}

			// if(this.shortTermRentalId)
			// {
			// 	// show only activities that are assigned to this activityId
			// 	let shortTermRentalIdFilter = { 'ShortTermRentalVO.shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
			// 	Object.assign(event.filters, shortTermRentalIdFilter);
			// }

			const pageNumber = Math.round(event.first / event.rows);
			this.compendiumShortTermRentalJoinService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.compendiumShortTermRentalJoins = res.data.compendiumShortTermRentalJoins;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.compendiumShortTermRentalJoins = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(compendiumShortTermRentalJoin: CompendiumShortTermRentalJoin) {
		try {
			this.formLoading = true;
			this.compendiumShortTermRentalJoinService.update(compendiumShortTermRentalJoin)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.compendiumShortTermRentalJoins.map((compendiumShortTermRentalJoin, i) => {
							if (compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId === res.data.compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId) {
								this.compendiumShortTermRentalJoins[i] = res.data.compendiumShortTermRentalJoin;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(compendiumShortTermRentalJoin: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(compendiumShortTermRentalJoin));

			this.formLoading = true;
			this.compendiumShortTermRentalJoinService.delete(compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.compendiumShortTermRentalJoins.splice(this.compendiumShortTermRentalJoins.indexOf(compendiumShortTermRentalJoin), 1);
						this.recordTotal = this.compendiumShortTermRentalJoins.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'CompendiumShortTermRentalJoin ' + compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'CompendiumShortTermRentalJoin ' + compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Compendium ShortTermRental Join',
			compendiumId: this.compendiumId,
			shortTermRentalId: this.shortTermRentalId,
			compendiumShortTermRentalFlag: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CompendiumShortTermRentalJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addCompendiumShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(compendiumShortTermRentalJoin: CompendiumShortTermRentalJoin) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			compendiumShortTermRentalJoin: compendiumShortTermRentalJoin,
			title: 'Edit Compendium ShortTermRental Join',
			compendiumId: this.compendiumId,
			shortTermRentalId: this.shortTermRentalId,
			compendiumShortTermRentalFlag: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CompendiumShortTermRentalJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateCompendiumShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.deleteCompendiumShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);
				this.reloadProperties.emit(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addCompendiumShortTermRentalJoinCB(compendiumShortTermRentalJoin: CompendiumShortTermRentalJoin) {
		console.log('Adding CompendiumShortTermRentalJoin: ' + JSON.stringify(compendiumShortTermRentalJoin));
		// if we don't have a compendiumShortTermRentalJoins array yet...
		if (!this.compendiumShortTermRentalJoins) {
			this.compendiumShortTermRentalJoins = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.compendiumShortTermRentalJoins.unshift(compendiumShortTermRentalJoin);

		// no idea what this is but it is required to update the array
		this.compendiumShortTermRentalJoins = [...this.compendiumShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CompendiumShortTermRentalJoin ' + compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId + ' Added', life: 3000 });
	}

	updateCompendiumShortTermRentalJoinCB(compendiumShortTermRentalJoin: CompendiumShortTermRentalJoin) {
		console.log('Updating CompendiumShortTermRentalJoin: ' + JSON.stringify(compendiumShortTermRentalJoin));
		let itemIndex = this.compendiumShortTermRentalJoins.findIndex((item: any) => item.compendiumShortTermRentalJoinId === compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId);
		this.compendiumShortTermRentalJoins[itemIndex] = compendiumShortTermRentalJoin;

		// no idea what this is but it is required to update the array
		this.compendiumShortTermRentalJoins = [...this.compendiumShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CompendiumShortTermRentalJoin ' + compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId + ' Updated', life: 3000 });
	}

	deleteCompendiumShortTermRentalJoinCB(compendiumShortTermRentalJoin: CompendiumShortTermRentalJoin) {
		console.log('Removing CompendiumShortTermRentalJoin: ' + compendiumShortTermRentalJoin);
		this.compendiumShortTermRentalJoins.splice(this.compendiumShortTermRentalJoins.indexOf(compendiumShortTermRentalJoin), 1);
		this.recordTotal = this.compendiumShortTermRentalJoins.length;

		// no idea what this is but it is required to update the array
		this.compendiumShortTermRentalJoins = [...this.compendiumShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CompendiumShortTermRentalJoin ' + compendiumShortTermRentalJoin.compendiumShortTermRentalJoinId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.compendiumShortTermRentalJoins ? this.first === (this.compendiumShortTermRentalJoins.length - this.rows) : true; }
	isFirstPage(): boolean { return this.compendiumShortTermRentalJoins ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(compendiumShortTermRentalJoin: any) {
		if (compendiumShortTermRentalJoin?.status) {
			const status = this.statuses.find((e: any) => e.value == compendiumShortTermRentalJoin.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getChargeType(compendiumShortTermRentalJoin: any) {
		if (compendiumShortTermRentalJoin?.chargeType) {
			const status = this.chargeTypes.find((e: any) => e.value == compendiumShortTermRentalJoin.chargeType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getFeeType(compendiumShortTermRentalJoin: any) {
		if (compendiumShortTermRentalJoin?.feeType) {
			const status = this.feeTypes.find((e: any) => e.value == compendiumShortTermRentalJoin.feeType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getFeeFrequencies(compendiumShortTermRentalJoin: any) {
		if (compendiumShortTermRentalJoin?.feeFrequency) {
			const status = this.feeFrequencies.find((e: any) => e.value == compendiumShortTermRentalJoin.feeFrequency);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	ngOnChanges() {
		/**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
		//Write your code here
		this.loadLazy(this.lazyLoadEvent);
		} 
}
